import { MasterInfoEnum, ROUTERS, TextMessage } from '@/constant';
import { useCommonList, useRowSelection } from '@/hooks';
import { insertObjectIfV2, showAlert } from '@/utils';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { TableRowSelection } from 'antd/es/table/interface';

import { TFilterWithViewAllRef } from '../common/filter-with-view-all/type';
import { getColumns, initialValues } from './config';
import { FranchiseItem, IProps } from './type';

export const useLogic = (props: IProps) => {
	const {
		publicFranchiseId,
		selectedFranchiseId,
		open,
		onBeforeSave,
		onSaveFranchise,
		onCancel,
		openFrom,
		isMultiple,
		shouldCallApi = true,
		programId,
	} = props;

	const rowSelection = useRowSelection<
		TableRowSelection<FranchiseItem>,
		FranchiseItem
	>({
		hideSelectAll: !isMultiple,
		isSingle: !isMultiple,
		getCheckboxProps(record) {
			return {
				disabled: record?.disabled,
			};
		},
	});

	const filterRef = useRef<TFilterWithViewAllRef>(null);

	useEffect(() => {
		if (!open) {
			filterRef?.current?.onReset?.();
			setParams((prev) => ({ ...prev, ...initialValues }));
			// Reset selection khi đóng modal
			rowSelection.setState({
				selectedRowKeys: [],
				selectedRows: [],
			});
		}
	}, [open, filterRef]);

	const [params, setParams] = useState({
		...initialValues,
	});

	const fetchData = useCallback((params: any) => {
		setParams((prev) => ({
			...prev,
			...params,
		}));
	}, []);

	const {
		commonList: { fetching, data },
	} = useCommonList<FranchiseItem>(
		openFrom === ROUTERS.RM1_02
			? MasterInfoEnum.RECOMMENDER_FRANCHISE
			: MasterInfoEnum.FRANCHISE,
		open && shouldCallApi,
		{
			...params,
			...insertObjectIfV2(publicFranchiseId, {
				publicFranchiseId,
			}),
			...insertObjectIfV2(programId, {
				programId,
			}),
		}
	);

	useEffect(() => {
		if (open && selectedFranchiseId && data && data.length > 0) {
			const selectedItem = data.find((item) => item.id === selectedFranchiseId);
			if (
				selectedItem &&
				!rowSelection.selectedRowKeys.includes(selectedFranchiseId)
			) {
				rowSelection.setState({
					selectedRowKeys: [selectedFranchiseId],
					selectedRows: [selectedItem],
				});
			}
		}
	}, [open, selectedFranchiseId, data]);

	const columns = useMemo(() => getColumns(), []);

	const onSaveClick = useCallback(() => {
		if (rowSelection?.selectedRowKeys?.length === 0) {
			showAlert(TextMessage.ALERT_5);
			return;
		}

		const keys = rowSelection.selectedRowKeys?.map(Number);
		const values = rowSelection.selectedRows;

		if (onBeforeSave?.(keys, values)) {
			return;
		}

		onSaveFranchise?.(keys, values);

		onCancel();
	}, [rowSelection, onBeforeSave, onSaveFranchise, onCancel]);

	return {
		filterRef,
		initialValues,
		fetchData,
		dataSource: data,
		columns,
		rowSelection,
		onSaveClick,
		loading: fetching,
	};
};
